// extracted by mini-css-extract-plugin
export var iconleft = "PageNavigation-module--iconleft--57c56";
export var iconright = "PageNavigation-module--iconright--d0034";
export var navigation = "PageNavigation-module--navigation--47b38";
export var navigationoptions = "PageNavigation-module--navigationoptions--a51ce";
export var pagenavigationoption = "PageNavigation-module--pagenavigationoption--4c853";
export var pagenavigationwrapper = "PageNavigation-module--pagenavigationwrapper--7d9e3";
export var pagenavsectionbreak = "PageNavigation-module--pagenavsectionbreak--fde33";
export var spacer = "PageNavigation-module--spacer--4808d";
export var text = "PageNavigation-module--text--6acc8";
export var title = "PageNavigation-module--title--e41fc";
export var titletext = "PageNavigation-module--titletext--b5fe2";